export default __webpack_public_path__ + "static/media/sketch-02.267fec57.jpg";